import { createFileRoute, redirect } from "@tanstack/react-router"

import { cleanEmptyParams } from "@/utilities/etc"

export const Route = createFileRoute("/welcome")({
  component: undefined,
  validateSearch: (search: Record<string, unknown>): { qr: string } =>
    cleanEmptyParams({
      qr: (search.qr as string) || "",
    }),
  beforeLoad: ({ search }) => {
    if (search.qr)
      throw redirect({
        to: "/qr/$qrLookupID/welcome",
        params: { qrLookupID: search.qr },
      })
    throw redirect({ to: "/" })
  },
})
